import React, { createContext, useReducer } from "react";

// 컨텍스트 생성
const TabContext = createContext();

const TAB_TITLES = {
    "/vehicle/manage": "차량 등록 및 현황",
    "/vehicle/waiting": "대기 현황",
    "/vehicle/garage": "차고지 관리",
    "/order/manage": "오더 현황 및 생성",
    "/order/shared": "공유 목록",
    "/order/received": "받은 목록",
    "/insurance/write": "보험 계약서 작성 및 발송",
    "/insurance/list": "보험 작성 목록",
    "/contract/write": "단기/장기 계약서 작성 및 발송",
    "/contract/list": "단기/장기 작성 목록",
    "/delivery/request": "탁송 신청",
    "/delivery/history": "탁송 이력",
    "/agreement/register": "계약 등록",
    "/agreement/status": "계약 현황",
    "/agreement/repayment-schedule": "대여료 상환 스케쥴",
    "/agreement/delinquency": "미수 관리",
    "/mileage/charge": "마일리지 충전",
    "/mileage/history": "마일리지 적립/사용 내역",
    "/points/history": "포인트 적립/사용 내역",
    "/mileage/withdraw": "마일리지 출금 요청",
    "/billing/request": "청구 요청",
    "/billing/status": "청구 현황 조회",
    "/billing/insurance": "보험대차 청구",
    "/billing/receipt": "수납 등록 및 현황",
    "/billing/unpaid": "미수금 현황",
    "/billing/invoice": "세금계산서 발행/확인",
    "/payment/register": "지급 등록 및 현황",
    "/settings/user-info": "사용자 정보",
    "/settings/account-management": "계정 관리",
    "/settings/rates": "대차요금표 관리",
    "/admin/notice": "공지사항",
    "/admin/additional-accounts": "추가 계정 관리",
    "/admin/branch-master": "지점 마스터 생성",
    "/admin/employee": "직원 생성",
    "/partnership/realtime": "실시간 제휴 관리",
    "/partnership/list": "제휴 목록",
    "/partnership/request-call": "콜 요청하기",
    "/partnership/request-list": "콜 요청 목록",
    "/dev/exception": "예외 처리",
};


// 리듀서 정의
const tabReducer = (state, action) => {
    switch (action.type) {
        case "ADD_TAB":
            const existingTabIndex = state.findIndex((tab) => tab.url.split("?")[0] === action.payload.url.split("?")[0]);
            let updatedTabs = [...state];

            // 동일한 URL의 앞부분이 있는 경우 해당 탭 삭제
            if (existingTabIndex > -1) {
                updatedTabs = updatedTabs.filter((tab, index) => index !== existingTabIndex);
            }

            // 새 탭 추가
            return [{ ...action.payload }, ...updatedTabs].slice(0, 8); // 최대 8개 탭 유지

        case "REMOVE_TAB":
            return state.filter((tab) => tab.url !== action.payload);

        default:
            return state;
    }
};

// 프로바이더 컴포넌트
export const TabProvider = ({ children }) => {
    const [state, dispatch] = useReducer(tabReducer, []);

    return <TabContext.Provider value={{ state, dispatch }}>{children}</TabContext.Provider>;
};

export default TabContext;
